"use client";

import type { ReactNode } from "react";
import { Checkbox } from "@/components/ui/checkbox";

export function FilterCheckboxInput({
  checked,
  onChange,
  children,
  label,
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  children: ReactNode;
  /** Accessible name for the checkbox when `children` is rich content. */
  label?: string;
}) {
  return (
    <div
      className="flex gap-1.5 items-center w-full min-w-[200px] cursor-pointer text-left"
      onClick={() => onChange(!checked)}
    >
      <div onClick={(e) => e.stopPropagation()} className="shrink-0">
        <Checkbox checked={checked} onChange={onChange} aria-label={label} />
      </div>
      <div className="flex-1 text-sm font-medium text-heading leading-5">{children}</div>
    </div>
  );
}
